/**
 * Returns a bundle of url + promo code related to an accountReferralType.
 *
 * @param {Object} account Account to get referral items from.
 * @param {string} accountReferralType Account referral type value.
 * @returns {{ affiliateUrl: Object, promoCode: Object }}
 */
const getReferralItemsByType = (account, accountReferralType) => {
  if (!account) {
    return {
      affiliateUrl: null,
      promoCode: null,
    };
  }

  const affiliateUrl = (account?.affiliate_urls?.records ?? []).find(
    affiliateUrlRecord => affiliateUrlRecord.type === accountReferralType,
  );
  const promoCode = (account?.promo_codes?.records ?? []).find(
    promoCodeRecord => promoCodeRecord.type === accountReferralType,
  );

  return {
    affiliateUrl,
    promoCode,
  };
};

export { getReferralItemsByType };
